import Component from "../../../../js/assets/component.js"
import Device from "../../../../js/assets/device.js"
import SlideShowItem from "./slideshow_item.js"

class SlideShowThumbnail extends Component {
  constructor(el) {
    super(el);
  }

  data(){
    return {
      "THUMBNAIL_TOTAL_NUM": null,
      "device_mode": null,
      "activeIndex": null,
      "slideIndex": null,
      "centerIndex": null,
      "THUMBNAIL_VIEW_NUM_SP": 3,
      "THUMBNAIL_VIEW_NUM_PC": 7,
      "thumbnailViewNum": null,
      "startLeft": 0,
      "slideItemWidth": 0,
      "slideContainerWidth": 0
    }
  }

  changed(){
    return {
      "THUMBNAIL_TOTAL_NUM": (val) => {
        this.noChange('THUMBNAIL_TOTAL_NUM')
        //PCでサムネが画面から溢れない時は中央寄せ
        if (val < this.$data.THUMBNAIL_VIEW_NUM_PC){
          this.$el.addClass("-center")
        }
      },
      "device_mode": (val) => {
        //change thumbnail view num
        switch (val) {
          case "sp":
            this.$data.thumbnailViewNum = this.$data.THUMBNAIL_VIEW_NUM_SP
            this.$data.centerIndex = 1
            break
          case "pc":
            this.$data.thumbnailViewNum = this.$data.THUMBNAIL_VIEW_NUM_PC
            this.$data.centerIndex = 3
            break
        }

        this.calcSlideContainerWidth()
        this.calcSlideItemWidth()
        this.slideInItem(this.$data.activeIndex)
      },
      "activeIndex": (index, prev)=>{
        this.activateItem(index)
        this.slideInItem(index)
      }
    }
  }

  mounted(){
    var self = this

    //event listener
    Device.addEventListener("device_mode", (data) => {
      this.$data.device_mode = data
    })

    //container
    this.$container = this.$el.find("[data-role='slideShowPagenation_items']")
    this.$container.css({
      position: "relative",
      top: 0,
      left: 0
    })

    //thumbnailItem
    this.thumbnailItem = []
    this.$container.find("li").each(function (i) {
      self.thumbnailItem.push(new SlideShowItem($(this).get(0)))
      self.thumbnailItem[i].loadImage()
      $(this).swipe({
        tap: function(){
          self.dispatchEvent("tap", i)
        }
      })
    })

    //swipe
    this.$el.swipe({
      triggerOnTouchLeave: true,
      triggerOnTouchEnd: true,
      threshold: 0,
      click: function (event) {
        event.preventDefault()
        event.stopPropagation()
      },
      allowPageScroll: "vertical",
      swipeStatus: function (event, phase, direction, distance, duration, fingers, fingerData, currentDirection) {
        self.swipeStatusHandler(event, phase, direction, distance, duration, fingers, fingerData, currentDirection)
      }
    });

    //init
    this.$data.device_mode = Device.$data.device_mode
    this.$data.THUMBNAIL_TOTAL_NUM = this.thumbnailItem.length
    this.calcSlideContainerWidth()
    this.calcSlideItemWidth()
    this.$data.activeIndex = 0;
  }

  calcSlideContainerWidth() {
    if (this.$container === undefined) {
      return
    }
    this.$data.slideContainerWidth = Number(this.$container.width() * this.$data.THUMBNAIL_TOTAL_NUM)
  }
  calcSlideItemWidth() {
    if (this.$container === undefined) {
      return
    }
    this.$data.slideItemWidth = Number(this.$container.width())
  }

  activateItem(index) {
    for (let i = 0; i < this.thumbnailItem.length; i++) {
      if (i === index) {
        this.thumbnailItem[i].activate()
      } else {
        this.thumbnailItem[i].inActivate()
      }
    }
  }

  calcSlideIndex(index) {
    if (index - this.$data.centerIndex < 0) {
      this.$data.slideIndex = 0
    } else if (index + this.$data.centerIndex >= this.$data.THUMBNAIL_TOTAL_NUM) {
      this.$data.slideIndex = this.$data.THUMBNAIL_TOTAL_NUM - this.$data.thumbnailViewNum
    } else {
      this.$data.slideIndex = index - this.$data.centerIndex
    }
  }

  /*
  * indexのアイテムを画面中央にスライドインする
  * デバイスが変わった時に計算し直すように
  */
  slideInItem(index) {
    if (this.$container === undefined){
      return
    }

    if (index >= this.$data.slideIndex && (index <= this.$data.slideIndex + this.$data.thumbnailViewNum - 1)){
      // return
    } else {
      this.calcSlideIndex(index)
    }

    let posLeft = -1 * (this.$data.slideIndex * 100) + "%"
    this.$container
        .stop(false,false)
        .animate({
          left: posLeft
        }, {
          duration: 500,
          easing: "easeOutCirc"
        })
  }

  slideTo(index) {
    let posLeft = -1 * (index * 100) + "%"
    this.$container
      .stop(false, false)
      .animate({
        left: posLeft
      }, {
          duration: 500,
          easing: "easeOutCirc"
        })
  }
  swipeThumbnail(direction, startLeft,  distance){
    let coefficient = 1
    switch (direction){
      case "right":
        coefficient = 1
        break
      case "left":
        coefficient = -1
        break
    }

    let posLeft = Number(startLeft) + (coefficient * distance)
    this.$container.css({
      "left": posLeft + "px"
    })
  }
  stickThumbnail(direction){
    let posLeft = Number(this.$container.css("left").replace(/(%|px)/, ""))

    if (posLeft > 0){
      this.slideInItem(0)
    } else if (this.$data.slideContainerWidth - Math.abs(posLeft) < $(window).width()){
      this.slideInItem(this.$data.THUMBNAIL_TOTAL_NUM-1)
    }else{
      let index = Math.round(Math.abs(posLeft)/this.$data.slideItemWidth)
      if(direction === "left"){
        index = index + 1
      }else if(direction === "right"){
        index = index - 1
      }else{
        index = index
      }
      this.slideTo(index)
    }
  }

  /*
  * スワイプ
  */
  async swipeStatusHandler(event, phase, direction, distance, duration, fingers, fingerData, currentDirection) {
    if (phase === "start") {
      this.dispatchEvent("swipeStart")
      this.$data.startLeft = Number(this.$container.css("left").replace(/(%|px)/, ""))
    }
    if (distance < 10) {
      this.dispatchEvent("swipeEnd")
      return
    }

    if (phase === "move" && (direction === "left" || direction === "right")) {
      this.swipeThumbnail(direction, this.$data.startLeft, distance)
    } else if (phase == "cancel" || phase == "end") {
      this.stickThumbnail(direction)
      this.dispatchEvent("swipeEnd")
    }
  }
}

export default SlideShowThumbnail
